import React from 'react'
import { Section } from '../../../../components/section'
import { ACard } from '../../components/card'
import { H2 } from '../../../../components/typography'
import { SecondaryText, SectionTitle } from '../atom'
import styled from 'styled-components'

const WrapFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  text-align: center;
`
const Title = styled(H2)`
  margin: 10px 0 0 0;
`
export interface AdvantagesProps {
  menuData: any
}

export function Advantages(props: AdvantagesProps) {
  const { menuData } = props
  return (
    <Section>
      <SectionTitle>方案优势</SectionTitle>
      <WrapFlex>
        {menuData.map((item: any) => (
          <ACard icon={item.icon}>
            <Title>{item.title}</Title>
            <SecondaryText>{item.description}</SecondaryText>
          </ACard>
        ))}
      </WrapFlex>
    </Section>
  )
}
